import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getAccountDetails = async (panelListId: number) => {
  return secureGet("/api/user/getPanelistDataForAccount", { panelListId });
};

export const UpdateUsername = async (panelistId: number, user_nicename: string) => {
  return securePost("/api/user/UpdatePanelistDataForAccount", { panelistId, user_nicename });
};

export const deactivateAccount = async () => {
  return securePost("/api/user/deactivate-account", {});
};

export const deleteAccount = async () => {
  return securePost("/api/user/delete-account", {});
};

export const changeUserPassword = async (panelistId: number, password: string, new_password: string) => {
  return securePost("/api/user/ChangePasswordPanelistDataForAccount", { panelistId, password, new_password });
};

export const decryptPassword = async (password: string) => {
  return securePost("/api/user/DecryptPassword", { password });
};

export const SubscribeAccount = async (panelListId) => {
  return securePost("/api/user/Subscribe", { panelListId });
};

export const UpdateGender = async (gender: string, panelListId: number) => {
  return securePost("/api/user/updateGender", { gender, panelListId });
};

export const UpdateDob = async (dob: string, panelListId: number) => {
  return securePost("/api/user/updateDob", { dob, panelListId });
};

export const uploadProfileImage = async (panelistId: number, image: File) => {
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  };
  try {
    const base64String = await convertToBase64(image);
    const payload = {
      panelistId,
      image: base64String
    };
    const response = await securePost("/api/user/imageUrl", payload);
    return response.data;
  } catch (error) {
    throw new Error('Failed to upload profile image');
  }
};
